module.exports = __webpack_public_path__ + "lit_001.6e9e32ea.png";